module.exports = __webpack_public_path__ + "img/jorge-gleizer.1ca1b324.jpg";